import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { TableColumn } from '@swimlane/ngx-datatable';
import * as bootstrap from 'bootstrap';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { HttpControllers } from 'src/app/utils/Class/HttpController';
import { DATA_SOURCE } from 'src/environments/environment';
import { UtilsService } from 'src/app/shared/utils/utils.service';

interface CsvSolped {
  orderDate: string
  promiseDate: string
  quantity: number
  quantityTo: number
  partNumber: number,
  errors?: any
}

interface DatosBancarios {
  idBanco: string;               // ID Banco
  cuentaBancaria: string;        // Cuenta bancaria
  claveBanco: string;            // Clave banco
  numeroReferencia: string;      // Número de referencia
  idEmpresa: string;             // ID Empresa
  numeroExtracto: string;        // Número de extracto
  fecha: string;            // Fecha
  monto: number;                 // Monto
  errors?: any
  observacion?: string[];         // Observación
  estado?: string;                // Estatus
}


@Component({
  selector: 'app-anula-extracto-banco',
  templateUrl: './anula-extracto-banco.component.html',
  styleUrls: ['./anula-extracto-banco.component.css']
})
export class AnulaExtractoBancoComponent implements OnInit {

  public alertStatusBehaviorSubject: BehaviorSubject<boolean> = new BehaviorSubject(null)
  public alertStatus$: Observable<boolean> = this.alertStatusBehaviorSubject.asObservable()

  public dataSource$ = new BehaviorSubject<DatosBancarios[]>([])

  public columns: TableColumn[] = [
    {
      // name: 'Id',
      prop: 'idBanco',
      width: 50,
    },
    {
      // name: 'descripcion',
      prop: 'cuentaBancaria',
      width: 50,
    },
    {
      // name: 'Id',
      prop: 'claveBanco',
      width: 50,
    },
    {
      // name: 'descripcion',
      prop: 'numeroReferencia',
      width: 50,
    },
    {
      // name: 'Id',
      prop: 'idEmpresa',
      width: 50,
    },
    {
      // name: 'Id',
      prop: 'idConciliacion',
      width: 50,
    },
    {
      // name: 'Id',
      prop: 'fechaContable',
      width: 50,
    },
    {
      // name: 'Id',
      prop: 'monto',
      width: 50,
    },
    /*{
      // name: 'Id',
      prop: 'observacion',
      width: 50,
    },*/
  ]

  constructor(
    private httpClient: HttpClient,
    private router:Router,
    private _util: UtilsService
  ) { }

  ngOnInit(): void {

  }

  public onLoadCsv($event: Event) {
    this.dataSource$.next([])
    const [file] = ($event.target['files'] as File[])
    const reader = new FileReader();
    reader.onload = ($fileReaderEvent) => {
      this.dataSource$.next(this.purgeJson((this.csvToJson(`${$fileReaderEvent.target.result}`) as DatosBancarios[]),this.columns))
    };
    reader.readAsText(file);

  }

  private csvToJson(strBlob: string, delimiter: string = ';') {
    const titles: string[] = strBlob
      .slice(0, strBlob.indexOf('\n'))
      .split(delimiter);
    return strBlob
      .slice(strBlob.indexOf('\n') + 1)
      .split('\n')
      .map(v => titles.reduce((obj, title, index) => ((obj[this.firstLetterToLowerCase(title.trim())] = v.split(delimiter)[index]), obj), {}));
  }

  private purgeJson(arrJsonDirty: {}[], arrRef: TableColumn[],): any {
    const arrJsonCleaned = arrJsonDirty.filter((item: { idBanco: string }) => item.idBanco !== '');
    console.log(arrJsonCleaned.length)
    return arrJsonCleaned
      .map((item) => arrRef
        .reduce((acc, column) => {
          if (item[this.firstLetterToLowerCase(`${column.prop}`)] !== undefined) acc[this.firstLetterToLowerCase(`${column.prop}`)] = item[this.firstLetterToLowerCase(`${column.prop}`)];
          return acc;
        }, {}));
  }
/*  private purgeJson(arrJsonDirty: {}[]): any {
    return arrJsonDirty
      .map((item) => this.columns
        .reduce((acc, column) => {
          if (item[this.firstLetterToLowerCase(`${column.prop}`)] !== undefined) acc[this.firstLetterToLowerCase(`${column.prop}`)] = item[this.firstLetterToLowerCase(`${column.prop}`)];
          return acc;
        }, {}));
  }*/

  private firstLetterToLowerCase(str: string) {
    return str.trim().charAt(0).toLowerCase() + str.trim().slice(1)
  }

  public submit(data: DatosBancarios[]) {
    new HttpControllers(this.httpClient)
      .create<DatosBancarios[]>({
        datasource: DATA_SOURCE.VDI,
        path: `cobros/anulaextracto`,
        body: data
      })
      .subscribe(
        {
          error: (err) => {
            this.dataSource$.next(err.error.respuesta)
            this.alertStatusBehaviorSubject.next(false)
            console.log("reject", this.alertStatusBehaviorSubject.value, err.error.respuesta)
          },
          next: (res) => {
            this.alertStatusBehaviorSubject.next(true)
            console.log(res.respuesta, this.dataSource$.getValue())
            this.dataSource$ = new BehaviorSubject<DatosBancarios[]>(res.respuesta)
            console.log("send")
          }
        },

      )
  }

  public  downloadCsvFormato() {
    let cabecera: any[] = [['idBanco;cuentaBancaria;claveBanco;numeroReferencia;idEmpresa;idConciliacion;fechaContable;monto']];
    const data: any[] = [
      { 'idBanco' : 'GY888','cuentaBancaria': '7008654','claveBanco': 'DEPOSITO','numeroReferencia': '9887','idEmpresa': 1001, 'numeroExtracto': 1999, 'fecha':"'2024-09-01", 'monto':'99.9'}
    ];
    let name: string = "formato_anulacion_extracto.csv";
    this._util.exportCSV(cabecera, data, name);
  }



}
